import { CategoricalColumn, StringColumn } from 'baseui/data-table';
import { CustomDateColumn, EMPTY_STRING } from 'commons-ui';
import 'reactjs-popup/dist/index.css';

export const COL_NAMES = {
	_id: '_id',
	gameName: 'gameName',
	downtimeType: 'downtimeType',
	startTime: 'startTime',
	endTime: 'endTime',
	createdBy: 'createdBy',
	createdAt: 'createdAt',
	approvedBy: 'approvedBy',
	approvedAt: 'approvedAt',
	status: 'status',
	csvPath: 'csvPath',
	totalRefundAmount: 'totalRefundAmount',
	affectedGamePlay: 'affectedGamePlay'
};

export const RefundRequestStatus: { [key: number]: string } = {
	0: 'IN_PROGRESS',
	1: 'WAITING_FOR_APPROVAL',
	2: 'APPROVED',
	3: 'REJECTED',
	4: 'FAILED'
};

export const RefundRequestListConfig = () => {
	return [
		StringColumn({
			title: 'Game Name',
			minWidth: 100,
			maxWidth: 250,
			mapDataToValue: (data: any) => data[COL_NAMES.gameName] || EMPTY_STRING
		}),
		CategoricalColumn({
			title: 'Downtime Type',
			minWidth: 200,
			maxWidth: 250,
			mapDataToValue: (data: any) => data[COL_NAMES.downtimeType] || EMPTY_STRING
		}),
		CustomDateColumn({
			title: 'Start Time',
			minWidth: 200,
			maxWidth: 300,
			columnName: COL_NAMES.startTime
		}),
		CustomDateColumn({
			title: 'End Time',
			minWidth: 200,
			maxWidth: 300,
			columnName: COL_NAMES.endTime
		}),
		StringColumn({
			title: 'Total Amount',
			minWidth: 100,
			maxWidth: 250,
			mapDataToValue: (data: any) => data[COL_NAMES.totalRefundAmount]
		}),
		StringColumn({
			title: 'Total User Impacted',
			minWidth: 100,
			maxWidth: 250,
			mapDataToValue: (data: any) => data[COL_NAMES.affectedGamePlay]
		}),
		StringColumn({
			title: 'Status',
			maxWidth: 300,
			mapDataToValue: (data: any) => {
				const status = data[COL_NAMES.status];
				return RefundRequestStatus[status] || 'Unknown Status';
			}
		}),
		StringColumn({
			title: 'Created By',
			minWidth: 200,
			maxWidth: 300,
			mapDataToValue: (data: any) => data[COL_NAMES.createdBy] || EMPTY_STRING
		}),
		CustomDateColumn({
			title: 'Created At',
			minWidth: 200,
			maxWidth: 300,
			columnName: COL_NAMES.createdAt
		}),
		CategoricalColumn({
			title: 'Approved/Rejected By',
			minWidth: 200,
			maxWidth: 300,
			mapDataToValue: (data: any) => data[COL_NAMES.approvedBy] || EMPTY_STRING
		}),
		CustomDateColumn({
			title: 'Approved/Rejected At',
			minWidth: 200,
			maxWidth: 300,
			columnName: COL_NAMES.approvedAt
		})
	];
};

export const DEFAULT_CONFIG: {
	pageDetails: {
		pageNo: number;
		pageSize: number;
	};
} = {
	pageDetails: {
		pageNo: 1,
		pageSize: 20
	}
};
